/** @type {Styles} */

export const styles = {
  position: {
    position: 'fixed',
    bottom: { xs: 88, md: 24 }, // On mobile, sit above the bottom navigation bar
    right: { xs: 16, md: 24 },
    // MUI's floating-button layer: above page content, below drawers and dialogs, so it never covers their actions.
    zIndex: 'speedDial',
  },
  color: {
    backgroundColor: 'gray.0',
    color: 'primary.main',
    boxShadow: '0px 1px 4px rgba(30, 32, 38, 0.16)',
    ':hover': {
      backgroundColor: 'gray.0',
    },
    ':active': {
      boxShadow: '0px 2px 5px rgba(30, 32, 38, 0.16)',
    },
    '.MuiTouchRipple-root': { color: 'gray.16' },
  },
  validCheckin: {
    color: 'success.main',
    '.MuiBadge-badge': {
      backgroundColor: 'success.main',
    },
  },
  inValidCheckin: {
    color: 'error.main',
    '.MuiBadge-badge': {
      backgroundColor: 'error.main',
    },
  },
  validCheckinWithAlerts: {
    color: 'warning.main',
    '.MuiBadge-badge': {
      backgroundColor: 'warning.main',
    },
  },
  defaultNoCheckin: {
    color: 'primary.main',
  },
  size: {
    boxShadow: 'gray',
    borderRadius: 8,
    height: 'auto',
    paddingY: 1,
    fontSize: 32,
  },
  floatButton: {
    position: 'relative',
    '& .MuiBadge-root': {
      height: 32,
      width: 32,
      position: 'absolute',
    },
  },
  resetAnimation: {
    animationName: 'none',
  },
  animation: {
    animationName: 'shakeY',
    animationDuration: '1s',

    '@keyframes shakeY': {
      '0%, 69.6%, 100%': {
        transform: 'translate(0,0)',
        animationTimingFunction: 'linear',
      },
      '13.3%': {
        transform: 'translate(0px, 5px)',
        animationTimingFunction: 'cubic-bezier(.82,.89,.9,1)',
      },
      '33.1%': {
        transform: 'translate(0, -6.61px)',
        animationTimingFunction: 'cubic-bezier(.62,.91,.78,.98)',
      },
      '55.8%': {
        transform: 'translate(0, 3.92px)',
        animationTimingFunction: 'cubic-bezier(.44,.52,.84,.53)',
      },
    },
  },
  badgeAnimation: {
    '.MuiBadge-badge': {
      animationName: 'pulse',
      animationDuration: '1s',
      animationTimeFunction: 'linear',
      '@keyframes pulse': {
        '0%, 40%, 100%': {
          transform: 'scale(1)',
        },
        '23.1%': {
          transform: 'scale(0.73)',
        },
        '32.6%': {
          transform: 'scale(1.18)',
        },
      },
    },
  },

  badge: {
    '.MuiBadge-badge': {
      transformOrigin: 'center',
      transform: 'scale(1)',
      position: 'absolute',
      typography: 'small',
      fontWeight: 600,
      bottom: '-50%',
      right: '-60%',
    },
  },
  hideFloatButton: {
    display: 'none',
  },
}
